import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter-layout__container" }
const _hoisted_2 = {
  key: 0,
  class: "filter-tab-navigation"
}
const _hoisted_3 = { class: "filter-layout__container--content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation_tab = _resolveComponent("navigation-tab")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["filter-layout__container--header", {hide: _ctx.hideNav}]),
      "data-cy": "layout-container"
    }, [
      _renderSlot(_ctx.$slots, "header", { filter: _ctx.filters }, () => [
        (_ctx.filters?.views?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.views.slice(0,1), (view) => {
                return (_openBlock(), _createBlock(_component_navigation_tab, {
                  class: "navigation-tab",
                  key: `navigation-tab-${view.id}`,
                  icon: "",
                  value: { id: view.id, name: 'O' },
                  active: _ctx.activeView === view.id,
                  onClick: _ctx.showView
                }, null, 8, ["value", "active", "onClick"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.views.slice(1,_ctx.MAX_MENU_ITEMS), (view) => {
                return (_openBlock(), _createBlock(_component_navigation_tab, {
                  class: "navigation-tab",
                  key: `navigation-tab-${view.id}`,
                  value: view,
                  active: _ctx.activeView === view.id,
                  onClick: _ctx.showView
                }, null, 8, ["value", "active", "onClick"]))
              }), 128)),
              (_ctx.filters.views.length > _ctx.MAX_MENU_ITEMS)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: _normalizeClass(["show-other", { active: _ctx.filters.views.slice(_ctx.MAX_MENU_ITEMS).some(v => _ctx.activeView === v.id) }]),
                    unelevated: "",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "t-icon lowercase" }, "d", -1)),
                      _createVNode(_component_q_menu, {
                        offset: [-40,7],
                        anchor: "bottom right",
                        "transition-duration": "100",
                        "auto-close": "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.views.slice(_ctx.MAX_MENU_ITEMS), (view) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              onClick: _withModifiers(($event: any) => (_ctx.showView(view)), ["stop"]),
                              clickable: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(view.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_close_popup]
                            ])
                          }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}